"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Share = void 0;
const cash_dom_1 = __importDefault(require("cash-dom"));
const globals_1 = require("./globals");
class Share {
    constructor(container) {
        this.sharebox = null;
        this.addition = null;
        this.og = null;
        // init sharebox
        this.sharebox = container;
        const og = globals_1.opengraphdata;
        if (og !== undefined) {
            // open share box
            (0, cash_dom_1.default)('.sharebox-open').on("click", (event) => {
                event.preventDefault();
                this.sharebox.show();
                const addition = (0, cash_dom_1.default)(event.target).attr('data-addition');
                (0, cash_dom_1.default)('.set .item', this.sharebox).each((index, item) => {
                    var _a;
                    let pattern = (_a = (0, cash_dom_1.default)('a', item).attr('data-url')) !== null && _a !== void 0 ? _a : '';
                    pattern = pattern === null || pattern === void 0 ? void 0 : pattern.replace("{url}", encodeURIComponent(og.url));
                    pattern = pattern === null || pattern === void 0 ? void 0 : pattern.replace("{img}", encodeURIComponent(og.image));
                    if (addition) {
                        pattern = pattern.replace("{title}", encodeURIComponent(addition));
                    }
                    else {
                        pattern = pattern.replace("{title}", encodeURIComponent(og.title));
                    }
                    pattern = pattern.replace("{title}", encodeURIComponent(og.title + ' ' + this.addition));
                    pattern = pattern.replace("{desc}", encodeURIComponent(og.description));
                    pattern = pattern.replace("{via}", encodeURIComponent(og.site_name));
                    pattern = pattern.replace("{hashtags}", encodeURIComponent(og.hashtags));
                    (0, cash_dom_1.default)('a', item).attr('href', pattern);
                });
            });
            // close share box
            (0, cash_dom_1.default)('.close', this.sharebox).on("click", (event) => {
                this.sharebox.hide();
            });
        }
    }
}
exports.Share = Share;
